import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ListaSolicitudReprocesoService = async (values) => {
	try {
		return await instance.Backend.post("/Indicador/ListaSolicitudReproceso", values, customConfig);
	} catch (error) {
		console.log(error);
	}
};

export { ListaSolicitudReprocesoService };
